import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  ApiError,
  TenderStates,
  ValidateTenderResponseResult,
} from 'net-api-lib';
import { TenderRouteNames } from '../../../routing.constants';

_('TENDER_ERROR.NO_ASSESSMENT_TEAM_FOR_VENDOR_ATTRIBUTES_SET');
_('TENDER_ERROR.NO_ASSESSMENT_TEAM_FOR_ITEM_ATTRIBUTE_SET');

@Component({
  selector: 'app-formly-repeat-editable-rating',
  imports: [FormlyModule, TranslateModule, MatButtonModule, MatIcon, MatCard],
  templateUrl: './formly-repeat-editable-rating.component.html',
  styleUrl: './formly-repeat-editable-rating.component.scss',
})
export class FormlyRepeatEditableRatingComponent extends FieldArrayType {
  tenderStates = TenderStates;

  private router = inject(Router);

  isInWizard = this.router.url.includes(TenderRouteNames.Wizard);

  validatedTenderInfo = computed(() => {
    const validatedTender =
      this.props.validatedTender() as ValidateTenderResponseResult;

    // Create a record to group errors by their translateKey (message)
    const groupedErrors: Record<string, any[]> = {};

    validatedTender.errors?.forEach((error: ApiError) => {
      const { message, metadata } = error;

      if (
        metadata?.validator === 'VendorAttributesAssessmentTeamValidator' ||
        metadata?.validator === 'ItemAttributeAssessmentTeamValidator'
      ) {
        // Initialize the array for this message if it doesn't exist
        if (!groupedErrors[message!]) {
          groupedErrors[message!] = [];
        }

        if (metadata?.isGroup) {
          const alreadyExists = groupedErrors[message!].some(
            item => item.itemOid === (metadata.itemOid as any)
          );

          // Add the item to the group if it doesn't already exist
          if (!alreadyExists) {
            groupedErrors[message!].push({
              name: metadata.name!,
            });
          }
        }
      }
    });

    // Transform the grouped errors into the desired format
    const formattedData = Object.entries(groupedErrors).map(
      ([translateKey, items]) => ({
        translateKey, // Key representing the error message
        groupNames: items.map(item => item.name), // Extract group names from the items
      })
    );

    return formattedData;
  });

  constructor() {
    super();
  }
}
